import React from 'react'

export const CustomIntegrationUpsellFeatures: React.FC = () => {
  return (
    <>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-success' />
        <div className='paragraph-medium'>
          <strong>Any MCP server</strong>: Register MCP servers by URL and make them available to your whole account.
        </div>
      </div>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-success' />
        <div className='paragraph-medium'>
          <strong>Your authentication</strong>: OAuth2, dynamic client registration, API keys, bearer tokens or basic auth, whatever the server handles.
        </div>
      </div>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-success' />
        <div className='paragraph-medium'>
          <strong>Private by default</strong>: Custom MCP servers stay visible only to your account and its sub-accounts.
        </div>
      </div>
    </>
  )
}
